"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactRelationType = void 0;
var ContactRelationType;
(function (ContactRelationType) {
    ContactRelationType["Locations"] = "Locations";
    ContactRelationType["Schools"] = "Schools";
})(ContactRelationType = exports.ContactRelationType || (exports.ContactRelationType = {}));
//# sourceMappingURL=ContactRelationType.js.map